<template>
    <section :class="`spec-sheet spec-sheet-our_story ${!props.rows.length ? 'center-align' : ''}`" :style="cssProps">
        <div class="spec-hero">
            <span
                :class="`headline-xl text-${props.headlineColor}`"
                id="spec-title"
                :style="textAlignClass"
                role="heading"
                aria-level="2"
                >{{ props.headline }}</span
            >
            <p v-if="props.body" :style="textAlignClass" :class="`text-${props.bodyColor}`">
                {{ props.body }}
            </p>
            <div class="cta-section" :style="!props.rows.length ?`padding: 1rem; align-self: center` : `padding: 1rem;`">
                <RothcoCta
                    v-if="props.cta.label"
                    :ctaType="props.cta.type"
                    :class="[...ctaClasses]"
                    v-bind="getCtaLink(props.cta)"
                    :aria-label="props.cta.aria_label"
                >
                    {{ props.cta.label }}
                </RothcoCta>
            </div>
        </div>
        <div
            :class="{'specs-container': true, 'mobile-hidden': props.mobileBadgesHidden}">
            <RowWithImage
                v-for="(row, rowIndex) in props.rows"
                :key="rowIndex"
                :heading="row.heading"
                :heading-color="row.headingColor"
                :subtext="row.subtext"
                :subtext-color="row.subtextColor"
                :image="row.image"
                :imageAlt="row.imageAlt"
                :text-align="row.textAlign"
                :picture-orientation="row.pictureOrientation"
                :id="`row_panel_item_${rowIndex}`"
                :lastItem="rowIndex == rows.length - 1"
            />
        </div>
    </section>
</template>
<script lang="ts" setup>
    import { type PropType, computed, ref } from "vue";
    import type { Cta } from "@/helpers/builder-init/index";
    import RothcoCta from "@/components/RothcoCta.vue";
    import RowWithImage from "@/components/RowWithImage.vue";
    import { getCtaLink } from "@/helpers/interfaces/Cta";
    import useImageOptimization from "@/helpers/composables/useImageOptimization";
    let props = defineProps({
        desktopBackgroundImage: {
            type: String,
            default: ""
        },
        mobileBackgroundImage: {
            type: String,
            default: ""
        },
        headline: {
            type: String,
            default: ""
        },
        headlineColor: {
            type: String,
            default: ""
        },
        body: {
            type: String,
            default: ""
        },
        bodyColor: {
            type: String,
            default: ""
        },
        textAlign: {
            type: String,
            default: "",
        },
        cta: {
            type: Object as PropType<Cta>,
            default() {
                return {};
            }
        },
        rows: {
            type: Array<Object>,
            default: []
        },
        mobileBadgesHidden: {
            type: Boolean,
            default: false
        },
    });

    let { optimize } = useImageOptimization();
    let cssProps = computed(() => {
        return {
            "--desktop-img-url": `url(${optimize(props.desktopBackgroundImage)})`,
            "--mobile-img-url": `url(${optimize(props.mobileBackgroundImage)})`
        };
    });

    const ctaClasses = computed(() => {
        let classes = [props.cta.style ? props.cta.style : "primary"];
        if (props.cta.size != "default") classes.push(props.cta.size);
        return classes;
    });
    let textAlignClass = computed(()=>{
        return {textAlign: props.textAlign ? props.textAlign : 'left'};
    })
</script>
